import { render, staticRenderFns } from "./KPI.pug?vue&type=template&id=566c2c8d&lang=pug&external"
import script from "./KPI.js?vue&type=script&lang=js&external"
export * from "./KPI.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports